import styled from "styled-components";

export const SubmitForm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 850px;
  height: 600px;
  border-radius: 30px;
  box-shadow: 0px 0px 22px 0px rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(12px);
  background-color: rgba(220, 220, 220, 0.7);
  @media (max-width: 768px) {
    max-width: 90%;
  }
`;
export const InnerForm = styled.div`
  display: flex;
  flex-direction: column;
  width: 90%;
  height: 90%;
`;
export const IdeaInput = styled.input`
  width: 85%;
  height: 30px;
  background: transparent;
  border: none;
  border-bottom: 3px solid #dcdcdc;
  color: #111;
  font-size: 20px;
  outline: none;
  transition: border-bottom 0.2s linear;
  margin-bottom: 25px;
  &:focus {
    border-bottom: 10px solid #dcdcdc;
  }
`;
